import React, { Component } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import CloseIcon from '@material-ui/icons/Close';

import FlexOne from '../../common-components/FlexOne';

import * as reducers from '../reducer';
import * as searchFormReducers from '../reducer/ReportSearchForm';
import * as healthDataReducers from '../../health-data/reducer';

import * as actionMgr from '../aciton-mgr';
import * as searchFormActionMgr from '../aciton-mgr/ReportSearchForm';
import * as healthDataActionMgr from '../../health-data/action-mgr';

import * as strings from '../../helpers/strings';

import { statusDescription, ERROR_REPORT_STATUS_OPEN, ERROR_REPORT_STATUS_CLOSE } from '../constants';
import { ERROR_TYPE_NOT_CONNECTED } from '../../health-data/constants';
// importing Css
import '../../index.css';

const styles = {
  detailList: {
    listStyle: "none",
    paddingLeft: 0
  },
  detailLabel: {
    display: "inline-block",
    width: 140
  }
}

class ReportSearchResult extends Component {
  constructor() {
    super();

    this.handleSelect = this.handleSelect.bind(this);
    this.handleCloseReport = this.handleCloseReport.bind(this);
    this.handleReopenReport = this.handleReopenReport.bind(this);
    this.state = {
      status: 0
    }
  }

  componentDidMount() {
    const { errorTypes, fetchErrorTypes } = this.props;
    if (!errorTypes[ERROR_TYPE_NOT_CONNECTED])
      fetchErrorTypes();
  }

  handleSelect = errorReport => () => this.props.selectErrorReport(errorReport.id);

  handleCloseReport = () => {
    const { selectedErrorReport, closeErrorReport } = this.props;
    closeErrorReport(selectedErrorReport);
  }

  handleReopenReport = () => {
    const { selectedErrorReport, reopenErrorReport } = this.props;
    reopenErrorReport(selectedErrorReport);
  }

  handleSortStatus = event => {
    const { filterStatus } = this.props;
    const statusId = parseInt(event.target.value, 10);
    this.setState({
      status: event.target.value
    })
    filterStatus(statusId);
  }

  render() {
    const { errorReports, openedDetailDialog, toggleDetailDialog, selectedErrorReport, errorTypes, getFilterStatusId, classes, isClosing, match } = this.props;

    return (
      <Paper>
        <Table className="errorReportTable">
          <TableHead>
            <TableRow>
              <TableCell width={200}>{strings.lblReferenceNumber}</TableCell>
              <TableCell width={70}>{strings.lblStationId}</TableCell>
              <TableCell width={300}>{strings.lblReceivedOn}</TableCell>
              <TableCell width={200}>

                <div style={{ display: 'inline-block', marginTop: '8px' }}> {strings.lblStatus} </div>

                <FormControl margin={strings.txtNormal} style={{ margin: '0px 10px', display: 'inline-block' }}>
                  <Select
                    value={this.state.status}
                    onChange={this.handleSortStatus}
                  >
                    <MenuItem value={0}>All</MenuItem>
                    {Object.keys(statusDescription).map(function (key, index) {
                      return <MenuItem value={key}>{statusDescription[key]}</MenuItem>
                    })}
                  </Select>
                </FormControl>

              </TableCell>
              <TableCell>{strings.lblMessage}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {errorReports.map(errorReport => {
              if (errorReport.status === getFilterStatusId || getFilterStatusId === 0) {
                return (
                  <TableRow hover key={errorReport.id} onClick={match.params.stationName ? null : this.handleSelect(errorReport)}>
                    <TableCell>{errorReport.id}</TableCell>
                    <TableCell>{errorReport.stationName}</TableCell>
                    <TableCell>{format(errorReport.createdDate, strings.dateTimeFormat)}</TableCell>
                    <TableCell>{statusDescription[errorReport.status]}</TableCell>
                    <TableCell>{errorReport.message}</TableCell>
                  </TableRow>
                )
              }
              return null;
            })}
          </TableBody>
        </Table>
        {selectedErrorReport &&
          <Dialog
            disableBackdropClick={true}
            open={openedDetailDialog}
            onClose={toggleDetailDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{selectedErrorReport.id} - {selectedErrorReport.stationName}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {selectedErrorReport.message}
              </DialogContentText>
              <ul className={classes.detailList}>
                <li><label className={classes.detailLabel}>Received on:</label>{format(selectedErrorReport.createdDate, strings.dateTimeFormat)}</li>
                <li><label className={classes.detailLabel}>Station error type:</label>{errorTypes[selectedErrorReport.errorType]}</li>
                <li><label className={classes.detailLabel}>Report status:</label>{statusDescription[selectedErrorReport.status]}</li>
              </ul>
            </DialogContent>
            <DialogActions>
              {selectedErrorReport.status === ERROR_REPORT_STATUS_OPEN && <Button onClick={this.handleCloseReport} color={strings.colorPrimary} disabled={isClosing} >{strings.lblCloseReport}</Button>}
              {selectedErrorReport.status === ERROR_REPORT_STATUS_CLOSE && <Button onClick={this.handleReopenReport} color={strings.colorPrimary} disabled={isClosing} >{strings.lblReopenReport}</Button>}
              <FlexOne />
              <Button onClick={toggleDetailDialog} color={strings.colorPrimary}><CloseIcon /></Button>
            </DialogActions>
          </Dialog>
        }
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  errorReports: reducers.getErrorReports(state),
  selectedErrorReport: reducers.getSelectedErrorReport(state),
  isClosing: reducers.getIsClosing(state),
  getFilterStatusId: reducers.getFilterStatusId(state),
  openedDetailDialog: searchFormReducers.getOpenedDetailDialog(state),
  errorTypes: healthDataReducers.getErrorTypes(state)
})

export default connect(mapStateToProps, {
  selectErrorReport: actionMgr.selectErrorReport,
  closeErrorReport: actionMgr.closeErrorReport,
  reopenErrorReport: actionMgr.reopenErrorReport,
  toggleDetailDialog: searchFormActionMgr.toggleDetailDialog,
  fetchErrorTypes: healthDataActionMgr.fetchErrorTypes,
  filterStatus: actionMgr.filterStatus
})(
  withStyles(styles)(
    withRouter(ReportSearchResult)
  )
);